import { StyleSheet, Text, View } from "@react-pdf/renderer";

const PageMarginLeft = "50px";
const PageMarginRight = "50px";
const PageMarginTop = "40px";
const PageMarginBottom = "40px";
const textSize = {
  VerySmall: "12px",
  Small: "14px",
  Large: "16px",
  VeryLarge: "18px",
};
const labelMinWidth = "50px";

const fontName = "ThSarabun";
export const BillStylesA4 = StyleSheet.create({
  document: {
    fontFamily: fontName,
    padding: "20px",
    fontSize: "16px",
  },
  headerLogo: {
    display: "flex",
    marginEnd: 10,
    // textAlign: "center",
  },
  logo: {
    // width: "50px",
    height: "50px",
  },
  companyBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  page: {
    display: "flex",
    paddingLeft: PageMarginLeft,
    paddingRight: PageMarginRight,
    paddingTop: PageMarginTop,
    paddingBottom: PageMarginBottom,
  },
  pageHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: PageMarginTop,
  },

  textLarge: {
    lineHeight: "0.9",
    fontSize: textSize.Large,
    paddingBottom: "2px",
  },
  textSmall: {
    fontSize: textSize.Small,
    lineHeight: "0.9",
  },
  textVerySmall: {
    fontSize: textSize.VerySmall,
    lineHeight: "0.9",
  },
  textVeryLarge: {
    lineHeight: "0.9",
    fontSize: textSize.VeryLarge,
    paddingBottom: "2px",
  },
  docuNameBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid black",
    paddingVertical: "3px",
    paddingHorizontal: "5px",
    borderRadius: "3px",
    marginBottom: "5px",
  },
  customerDetailBox: {
    flex: "1",
    border: "1px solid #9b9999",
    borderRadius: "5px",
    padding: "10px",
    marginHorizontal: "2px",
  },

  textLabel: {
    fontSize: textSize.Small,
    fontWeight: "bold",
    paddingRight: "5px",
  },
  textValue: { fontSize: textSize.Small, paddingHorizontal: "0px", flex: "1" },
  textValueNoFlex: { fontSize: textSize.Small, paddingHorizontal: "5px" },
  horizonView: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },

  verticalCenter: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
    paddingVertical: "10px",
    paddingHorizontal: "30px",
  },

  itemSmall: {
    fontSize: textSize.Small,
  },
  itemRow: {
    display: "flex",
    flexDirection: "row",
  },
  itemStep: {
    paddingLeft: "5px",
    width: "30px",
    fontSize: textSize.Small,
  },
  itemCode: {
    width: "60px",
    fontSize: textSize.Small,
  },
  itemName: {
    display: "flex",
    flex: "1",
    fontSize: textSize.Small,
  },
  itemFlex: {
    display: "flex",
    flex: "1",
    fontSize: textSize.Small,
  },
  itemQty: {
    fontSize: textSize.Small,
    width: "100px",
    textAlign: "right",
  },
  itemPrice: {
    fontSize: textSize.Small,
    width: "100px",
    textAlign: "right",
  },
  itemTotal: {
    fontSize: textSize.Small,
    width: "100px",
    textAlign: "right",
    paddingRight: "5px",
  },
  itemHeader: {
    backgroundColor: "#c3e6faff",
  },

  drawLine: { borderBottom: "0.5px solid #444444" },
  drawDottedLine: { borderBottom: "1px dotted #444444" },

  verticalSpacing: { height: "5px" },
  thaiBaht: {
    display: "flex",
    backgroundColor: "#dfdfdf",
    justifyContent: "center",
    alignItems: "center",
    fontSize: textSize.Small,
  },
  p1Underline: {
    fontSize: textSize.Small,
    paddingTop: "10px",
    paddingBottom: "0px",
    marginBottom: "-5px",
    fontWeight: "bold",
    textDecoration: "underline",
  },
});

export const GetCenterTextView = (label) => {
  return (
    <View>
      <Text style={BillStylesA4.textLabel}>{label}</Text>
    </View>
  );
};
export const GetVerySmallTextView = (label) => {
  return (
    <View>
      <Text style={{ ...BillStylesA4.textVerySmall, lineHeight: 1.2 }}>
        {label}
      </Text>
    </View>
  );
};
